import {
  Button,
  ButtonProps,
  CircularProgress,
  useTheme,
} from '@material-ui/core'
import { CSSProperties } from '@material-ui/core/styles/withStyles'
import { Check } from '@material-ui/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void | Promise<unknown>
  saving?: boolean
  progress?: number
  translationKey?: string
  marginTop?: string
  formId?: string
}

export const SaveButton = (props: ButtonProps & Props) => {
  const { t } = useTranslation()
  const styles: CSSProperties = {}
  const theme = useTheme()

  const { saving, progress, translationKey, formId, ...buttonProps } = props

  if (props.marginTop) {
    styles.marginTop = props.marginTop
  }

  return (
    <Button
      {...buttonProps}
      type="submit"
      color={props.color || 'primary'}
      variant={props.variant || 'contained'}
      onClick={props.onClick}
      disabled={props.disabled || saving}
      style={{ ...buttonProps.style, ...styles }}
      form={formId}
      startIcon={
        saving ? (
          <CircularProgress
            variant={progress ? 'determinate' : 'indeterminate'}
            value={progress}
            size={20}
            style={{ marginRight: '1ch' }}
          />
        ) : (
          props.startIcon ?? (
            <Check
              htmlColor={`${
                props.disabled
                  ? theme.palette.action.disabled
                  : theme.palette.success.light
              }`}
            />
          )
        )
      }
    >
      {t(translationKey || 'common:save')}
    </Button>
  )
}
